// extracted by mini-css-extract-plugin
export default {"notice":"KznjNPCLP0zzsOyjq4vN","alert":"APvxShhpfQjwZgXFcQA7","flashMessage":"GM4uIOui7C1azzaeQ0QC","show":"AiXvvm9SuE89lXA5xrc2","hide":"X5rSiDVC8Ysbr5I4zd0v"};